<template>
  <router-view />
</template>

<script>
export default {
  name: 'SyllabusIndex'
}
</script>
